<template>
  <div :class="{ 'has-error': errorMessages.length > 0 }">
    <editor
      ref="editor"
      :disabled="disabled"
      :value="value"
      model-events="change keydown blur focus paste input"
      api-key="q20nemaanvbywzuwgisyaugqa8gd8e05n9zmfeffi0o8wo5z"
      :init="{
        placeholder: placeholder,
        branding: false,
        menubar: false,
        plugins: 'lists link image autoresize code paste media',
        image_list: route('tiny-mce.images.index').toString(),
        paste_as_text: false,
        min_height: 300,
        skin: 'webcomet',
        content_css: 'webcomet',
        //entity_encoding : 'raw',
        //force_br_newlines: false,
        //force_p_newlines: false,
        //forced_root_block: '',
        images_upload_url: route('upload-image.store'),
        images_upload_handler: imageUploadHandler,
        media_url_resolver: mediaUrlResolver,
        relative_urls: false,
        convert_urls: false,
        toolbar: 'styleselect | fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link | image | media | code',
        toolbar_sticky: true,
        toolbar_sticky_offset: 64,
        media_live_embeds: true,
        language: getLanguage(),

      }"
      v-on="$listeners"
      @input="handleInput"
    />
    <div class="pl-3 mt-2">
      <VMessages
        :value="internalErrorMessages"
        color="error"
      />
    </div>
  </div>
</template>

<script>
import VInput from 'vuetify/lib/components/VInput/VInput';
import Editor from '@tinymce/tinymce-vue';

export default {
  components: {
    Editor
  },

  extends: VInput,

  props: {
    value: {
      type: [String],
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean
    }
  },

  methods: {
    mediaUrlResolver(data, resolve) {
      const shortsRegex = /https?:\/\/(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/;

      if (shortsRegex.test(data.url)) {
        // Convert Shorts URL to embeddable URL
        const embedUrl = data.url.replace('/shorts/', '/embed/');
        resolve({ html: `<iframe width="560" height="315" src="${embedUrl}" frameborder="0" allowfullscreen></iframe>` });
      } else {
        // Default behavior for other media URLs
        resolve({ html: '' });
      }
    },

    imageUploadHandler(blobInfo, success, failure, progress) {
      var xhr, formData;

      xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', this.route('upload-image.store').toString());

      xhr.upload.onprogress = function (e) {
        progress(e.loaded / e.total * 100);
      };

      xhr.onload = function () {
        var json;

        if (xhr.status === 403) {
          failure(xhr.responseText, { remove: true });
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure('HTTP Error: ' + xhr.status);
          return;
        }

        json = JSON.parse(xhr.responseText);

        if (!json || typeof json.location != 'string') {
          failure('Invalid JSON: ' + xhr.responseText);
          return;
        }

        success(json.location);
      };

      xhr.onerror = function () {
        failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
      };

      formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());

      xhr.send(formData);
    },

    handleInput(value) {
      this.$nextTick(() => {
        this.$emit('input', value);
      });
    },

    getLanguage() {
      const current = this.$page.props.app_locales.current.code;

      switch (current) {
        case 'sv':
          return 'sv_SE';

        case 'fr':
          return 'fr_FR';

        case 'pt':
          return 'pt_BR';

        default:
          return current;
      }
    }
  },
}
</script>

<style>
.has-error .tox-tinymce {
  border: 2px solid var(--v-error-base) !important;
  border-radius: 4px;
}

.tox-tinymce--disabled {
  opacity: 0.8;
}

.tox-tinymce--disabled iframe {
  opacity: 0.3;
}
</style>